// components/user/lead/sell-device/TermsAndSubmit.jsx
import React from "react";
import { Checkbox } from "antd";

const TermsAndSubmit = ({ formik, submitting, onSubmit, isDarkMode }) => (
  <div className="space-y-4">
    <div className={`flex items-start gap-3 p-4 rounded-lg  ${isDarkMode ? "bg-gray-700" : "bg-gray-50"}`}>
      <Checkbox
        checked={formik.values.agreed}
        onChange={(e) => formik.setFieldValue("agreed", e.target.checked)}
        className="mt-0.5"
      />
      <span className={`text-sm ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
        We offer the maximum price of your device. The final amount will be confirmed during
        the visit by our technician after <span className="font-semibold">DEVICE DIAGNOSIS</span>.
        <br />
        <br />
        Your calls and communication with the vendor may be recorded for transparency,
        quality assurance, dispute resolution, and to improve our services. By proceeding,
        you consent to such recording and monitoring.
      </span>
    </div>
    {formik.touched.agreed && formik.errors.agreed && (
      <div className="text-xs text-center text-red-500">{formik.errors.agreed}</div>
    )}

    <button
      onClick={onSubmit}
      disabled={submitting}
      className="w-full py-3.5 font-semibold text-white transition-all bg-green-500 rounded-xl hover:bg-green-600 disabled:bg-gray-400 disabled:cursor-not-allowed"
    >
      {submitting ? (
        <div className="flex items-center justify-center gap-2">
          <div className="w-4 h-4 border-2 border-white rounded-full border-t-transparent animate-spin"></div>
          Creating Service Request...
        </div>
      ) : (
        "Schedule Pickup"
      )}
    </button>
  </div>
);

export default TermsAndSubmit;